import { render, staticRenderFns } from "./StatusIndicator.vue?vue&type=template&id=225cc02c&scoped=true&"
import script from "./StatusIndicator.vue?vue&type=script&lang=js&"
export * from "./StatusIndicator.vue?vue&type=script&lang=js&"
import style0 from "./StatusIndicator.vue?vue&type=style&index=0&id=225cc02c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225cc02c",
  null
  
)

export default component.exports